import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {DataTableRow as RmwcDataTableRow} from '@rmwc/data-table'
import '@rmwc/data-table/styles'

// eslint-disable-next-line no-unused-vars,react/prop-types
const FilteredRmwcDataTableRow = ({strikethrough, ...otherProps}) => <RmwcDataTableRow {...otherProps} />

export const dataTableRowStyles = ({selector = '&&&'}) => css`
  ${selector} {
    border-top-color: var(--mdc-theme-neutral3);
  }
  ${selector}:not(.mdc-data-table__row--selected):not(.mdc-data-table__header-row):hover {
    background-color: var(--mdc-theme-neutral2);
  }
  ${selector}.rmwc-data-table__row--activated {
    border-top-color: var(--mdc-theme-neutral3);
  }
`

const StyledRmwcDataTableRow = styled(FilteredRmwcDataTableRow)`
  ${dataTableRowStyles}
  ${(props) =>
    props.strikethrough &&
    `
    &&& .mdc-data-table__cell:before {
      content: ' ';
      position: absolute;
      top: 50%;
      left: 0;
      border-bottom: 1px solid var(--mdc-theme-neutral4);
      width: 100%;
    }

    &&& .mdc-data-table__cell:after {
      content: '\\00B7';
    }
  `}
`

const DataTableRow = ({children, ...otherProps}) => (
  <StyledRmwcDataTableRow role="row" {...otherProps}>
    {children}
  </StyledRmwcDataTableRow>
)

DataTableRow.propTypes = {
  children: PropTypes.any
}

export {DataTableRow}
